import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { foldersKeys } from '../../folders'
import { ISiteBoxDocument } from '@core/entities/SiteBoxDocument'

export const useCreateSiteBoxDocument = (
  options?: UseMutationOptions<
    ISiteBoxDocument,
    RequestErrorType,
    RequestTypes['createDocument']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...siteBoxDocumentsKeys.createDocument,
    onSuccess: (data: ISiteBoxDocument) => {
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byId({ documentId: data.id }).queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
    ...options,
  })
}
